import { render, staticRenderFns } from "./stickerForm.vue?vue&type=template&id=8677a0ca"
import script from "./stickerForm.vue?vue&type=script&lang=js"
export * from "./stickerForm.vue?vue&type=script&lang=js"
import style0 from "./stickerForm.vue?vue&type=style&index=0&id=8677a0ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports